import { apiCall, customAxios } from "./Interceptor";

const LANDING_COST_CALCULATOR = "/capacity/landing-cost/calculator/public";
const MATCH_MAKING_PROFILES_GENERATOR = "/capacity/landing-cost/matchmaking/generator";
const MATCH_MAKING_PROFILES_CONSUMER = "/capacity/landing-cost/matchmaking/consumer";
const UPLOAD_EXCEL_SHEET = "/capacity/landing-cost/upload-excel";

const getLandingCostCalculator = async (data) => {
    const response = await apiCall.post(LANDING_COST_CALCULATOR,data);
    return response;
}

const getMatchMakingProfilesGenerator = async (id,data) => {
    const response = await apiCall.post(`${MATCH_MAKING_PROFILES_GENERATOR}?capacityId=${id}`,data);
    return response;
}

const getMatchMakingProfilesConsumer = async (id,data) => {
    const response = await apiCall.post(`${MATCH_MAKING_PROFILES_CONSUMER}?capacityId=${id}`,data);
    return response;
}
const uploadLccExcelSheet = async (file,config) => {
    const response = await customAxios.post(UPLOAD_EXCEL_SHEET, file, config ? config : null);
    return response;
}
export default {
    getLandingCostCalculator,
    getMatchMakingProfilesGenerator,
    getMatchMakingProfilesConsumer,
    uploadLccExcelSheet,
};
